var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightSlim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.85,5.85l-5,5a.48.48,0,0,1-.7,0,.48.48,0,0,1,0-.7L25.29,6H.5a.5.5,0,0,1,0-1H25.29L21.15.85a.48.48,0,0,1,0-.7.48.48,0,0,1,.7,0l5,5a.36.36,0,0,1,.11.16.5.5,0,0,1,0,.38A.36.36,0,0,1,26.85,5.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightSlim);
export default __webpack_public_path__ + "static/media/arrow-right-slim.0f7172a3bef67315b4de101fcce60d9d.svg";
export { ForwardRef as ReactComponent };